import { useEffect } from "react";

// Seitentitel, Meta-Description, robots und Canonical-URL für die aktuelle Seite setzen.
// scripts/prerender.mjs übernimmt Titel und Description beim Vorab-Rendering ins HTML (auch in og:/twitter:-Tags)
// und setzt dort die Canonical-URL je Route. Titel ca. 50–65 Zeichen, Description ca. 120–160 Zeichen.
//   usePageMeta({ title, description, path: "/baumpflege" })
//   usePageMeta({ title, description, robots: "noindex, follow" })  – Seite nicht in die Suche aufnehmen
// "path" ist die kanonische Adresse (kleingeschrieben). Ohne path wird kein Canonical gesetzt (ein vorhandener entfernt).
// Parameter: title, description (Pflicht), robots (Standard "index, follow"), path (kanonischer Pfad, "/" = Startseite).
const SITE = "https://www.forstundflur.de";

function setTag(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function usePageMeta({ title, description, robots = "index, follow", path }) {
  useEffect(() => {
    if (title) document.title = title;
    const meta = (name) => () => {
      const m = document.createElement("meta");
      m.setAttribute("name", name);
      return m;
    };
    if (description) setTag('meta[name="description"]', meta("description"), "content", description);
    setTag('meta[name="robots"]', meta("robots"), "content", robots);
    if (path) {
      const link = () => {
        const l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        return l;
      };
      setTag('link[rel="canonical"]', link, "href", SITE + (path === "/" ? "" : path));
    } else {
      // z. B. Fehlerseite nach Klick innerhalb der Seite: Canonical der vorherigen Seite nicht stehen lassen
      document.head.querySelector('link[rel="canonical"]')?.remove();
    }
  }, [title, description, robots, path]);
}
